/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import { connect } from 'react-redux';
import {
  CASH_ON_HAND,
  EQUIPMENT_PREQUALIFIED,
  INCLUDE_IMPEDANCE_LONG_LEAD_TIME,
  IS_DENSE_URBAN_AREA,
  MAX_WALKABLE_STORY,
  PREQUALIFIED_ACC_GROUND,
  PREQUALIFIED_DESIGN_CODE_YEAR,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';

import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';
import RepairTimeOptionsSection from './RepairTimeOptionsSection.jsx';

const mapStateToProps = (state, ownProps) => {
  const { form } = ownProps;
  const { selectFormFieldVisibility, selectFormValues } = modelTypesByForm[form];
  return {
    showDefaultATC138Fields: selectFormFieldVisibility(state)(CASH_ON_HAND),
    showIsDenseUrbanArea: selectFormFieldVisibility(state)(IS_DENSE_URBAN_AREA),
    showMaxWalkableStory: selectFormFieldVisibility(state)(MAX_WALKABLE_STORY),
    showEquipmentPrequalified: selectFormFieldVisibility(state)(EQUIPMENT_PREQUALIFIED),
    showPrequalifiedDesignCodeYear: selectFormFieldVisibility(state)(PREQUALIFIED_DESIGN_CODE_YEAR),
    showPrequalifiedDetails: selectFormFieldVisibility(state)(PREQUALIFIED_ACC_GROUND),
    showIncludeImpedanceLongLeadTimeWarning:
      selectFormValues(state, INCLUDE_IMPEDANCE_LONG_LEAD_TIME) === false,
  };
};

export default connect(mapStateToProps)(RepairTimeOptionsSection);
